import { SocialIconProps } from './types';

const Remerge = ({ dimension, ...props }: SocialIconProps) => (
  <svg
    width={dimension || 24}
    height={dimension || 24}
    viewBox="255 6.5 215 215"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="#000000"
      d="M408.7 39.9c-18.1 0 -31.9 8.5 -37.8 23.3h-.2V41.7h-47.9c-16.5 0 -26.5 7.3 -31.5 22.9h-18.2v123.1h20v-81.8c0 -31.1 9.3 -46.3 28.4 -46.3h31.1v128.1h20v-93c0 -21.4 13.2 -36.4 32.2 -36.4 16.3 0 27.2 12.6 27.2 31.3v98.1h20v-101c-.2 -28.5 -17.1 -46.8 -43.3 -46.8z"
    />
  </svg>
);
export default Remerge;
